import { DEFAULT_GAME_ID, LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getAllCurrencyService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getGameDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-details', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const verifyRoundHashService = (data) => {
  console.log('data: ', data)
  let endPoint = ''
  let payLoadData = {}

  switch (data.gameId) {
    case DEFAULT_GAME_ID.CRASH:
      endPoint = 'fast-games/crash-game/check-provable-fair'
      payLoadData = {
        roundHash: data.hashCode,
        currencyCode: data.currencyCode
      }
      break
      
    case DEFAULT_GAME_ID.DICE:
      endPoint = 'fast-games/dice-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    default:
      break
  }
  return axiosInstanceService(METHOD_TYPES.post, endPoint, payLoadData, {
    server: microServices.SERVICE_URL_1
  })
}
